import React, { useCallback } from 'react';
import { Container, FileIconDiv } from '../styles';
import Filedata from '../../../../component/fileData';
import { extensionName, calculateDay, formatDateWithTime } from '../../../../helpers/common';
import { FILE_EXTENSIONS, IMAGE_EXTENSIONS, FILE_TYPES } from '../../../../global/constants';
import FileSVGIcon from '../../../../assets/images/svg/filesIconSvg';
import Image from '../../../../component/image';
import { FileType } from '../../../../component/fileUploadCard/styles';
import { FileGridProps } from '../../../../interfaces/ProjectInterface';
import { RawProjectFile } from '../../../../mobx/interfaces/project';

// Memoized item component that stabilizes the onClickFile callback per-item
const FileItem: React.FC<{
  item: RawProjectFile;
  isSelected: boolean;
  setCurrentItem: (item: RawProjectFile | null) => void;
  onClickFile: (item: RawProjectFile) => void;
  onClickRename: () => void;
  openModal: () => void;
  openDeleteModel: () => void;
}> = React.memo(function FileItem({
  item,
  isSelected,
  setCurrentItem,
  onClickFile,
  onClickRename,
  openModal,
  openDeleteModel
}) {
  const extension = extensionName(item).toLowerCase();

  const handleClickFile = useCallback(() => {
    onClickFile(item);
  }, [onClickFile, item]);

  return (
    <Filedata
      isImage={IMAGE_EXTENSIONS.includes(extension)}
      header={
        (!item?.uploadFileType || item?.uploadFileType === FILE_TYPES.UPLOAD) &&
        !FILE_EXTENSIONS.includes(extension) ? (
          <FileIconDiv>
            <FileSVGIcon name={'blank'} height='60' width='60' viewBox='0 0 60 60' />
            <FileType fontSize={extension?.length <= 5 ? 11 : 12} className='file-text'>
              {extension?.split('.')?.pop()?.toUpperCase()}
            </FileType>
          </FileIconDiv>
        ) : (
          <>
            {IMAGE_EXTENSIONS.includes(extension) ? (
              <Image alt='file_type_image' src={item?.url} height='100%' width='100%' objectFit='contain' />
            ) : (
              <FileSVGIcon
                name={
                  !item?.uploadFileType || item?.uploadFileType === FILE_TYPES.UPLOAD
                    ? extension
                    : `icon_${item?.uploadFileType}`
                }
                height='60'
                width='60'
                viewBox='0 0 60 60'
              />
            )}
          </>
        )
      }
      title={item.name}
      itemData={item}
      endtext={`${calculateDay(item.createdOn)} by ${item?.user?.name || 'unknown'}`}
      endTextTooltip={formatDateWithTime(item.createdOn)}
      onClickRename={onClickRename}
      OpenModal={openModal}
      Opendeletemodel={openDeleteModel}
      onClickFile={handleClickFile}
      fileType={item?.uploadFileType}
      isSelected={isSelected}
      setCurrentItem={setCurrentItem}
    />
  );
});

const FileGrid: React.FC<FileGridProps> = React.memo(function FileGrid({
  files,
  currentItem,
  setCurrentItem,
  onClickFile,
  onClickRename,
  openModal,
  openDeleteModel
}) {
  return (
    <Container>
      {files.map((item) => (
        <FileItem
          key={item?.id}
          item={item}
          isSelected={currentItem?.id === item?.id}
          setCurrentItem={setCurrentItem}
          onClickFile={onClickFile}
          onClickRename={onClickRename}
          openModal={openModal}
          openDeleteModel={openDeleteModel}
        />
      ))}
    </Container>
  );
});

export default FileGrid;
